/**
 * Lightweight cookie/notice banner — required for CRM sites holding PII.
 * Appears once until dismissed; stored in localStorage.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useAuth } from "../lib/auth";

const KEY = "ssc_cookie_ack_v1";
const SESSION_KEY = "ssc_cookie_ack_session";

export default function CookieNotice() {
  const [show, setShow] = useState(false);
  const { user } = useAuth();
  useEffect(() => {
    // Auto-hide once a user signs in (their consent is implicit)
    if (user) { setShow(false); return; }
    try {
      if (localStorage.getItem(KEY)) return;
      if (sessionStorage.getItem(SESSION_KEY)) return;
      setShow(true);
    } catch { /* noop */ }
  }, [user]);
  const dismiss = () => {
    try {
      localStorage.setItem(KEY, String(Date.now()));
      sessionStorage.setItem(SESSION_KEY, "1");
    } catch { /* noop */ }
    setShow(false);
  };
  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-md z-[60] rounded-2xl bg-[var(--ssc-navy)] text-white border border-white/15 shadow-2xl p-4" data-testid="cookie-notice">
      <div className="flex items-start gap-3">
        <div className="flex-1 text-sm">
          <strong className="text-[var(--ssc-blue)]">Privacy notice.</strong>{" "}
          We use essential cookies for login + chat. We do not run ad-tracking. We collect your name, contact info, and vehicle interest only when you give it to us. See our{" "}
          <Link to="/privacy" className="underline font-bold">Privacy Policy</Link> and{" "}
          <Link to="/terms" className="underline font-bold">Terms</Link>.
        </div>
        <button onClick={dismiss} className="text-white/60 hover:text-white shrink-0" data-testid="cookie-dismiss" aria-label="Dismiss">
          <X size={18} />
        </button>
      </div>
      <div className="mt-3 flex gap-2">
        <button onClick={dismiss} className="ssc-btn ssc-btn-primary text-xs px-3" data-testid="cookie-accept">Got it</button>
      </div>
    </div>
  );
}
